import { createContext, useEffect, useState } from "react";
import { fetchAccountInfo } from "../utils/commonAPI";
import { useNotify } from "../components/NotificationComponent";
export const UserContext = createContext()


export default function UserState({children}) {
    const [userInfo, setUserInfo] = useState(undefined)
    const [userMetaInfo, setUserMetaInfo] = useState({})
    const [activeUrl, setActiveUrl] = useState('/')
    const { notify } = useNotify()
    useEffect(()=>{
        const userInfo_ = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : undefined
        if(userInfo_){
            // get the user meta info
            fetchAccountInfo().then(res => {
                setUserInfo(userInfo_)
                setUserMetaInfo(res)
            }).catch(err => {
                localStorage.removeItem('userInfo')
                return notify('Please login again, token has expi')
            })
        }
        const path = window.location.pathname
        setActiveUrl(path)
    },[])
    return(
        <UserContext.Provider
            value={{
                userInfo, setUserInfo,
                activeUrl, setActiveUrl,
                userMetaInfo, setUserMetaInfo
            }}
        >
            {children}
        </UserContext.Provider>
    )
} 